export const LANGUAGE_CURRENT_SET = "LANGUAGE_CURRENT_SET";

export const setLanguage = (text) => ({
  type: LANGUAGE_CURRENT_SET,
  payload: text,
});
